export default "__VITE_ASSET__BzAQ0GFF__"